import './index.less';
import { Button, Tooltip, message } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { CodeEditor } from '@/components/need-to-lib/code-editor';
import { NavigationContext } from '@/App';
import { useLocation, useParams } from 'react-router-dom';
import { findGroupMapListByType, findParamFormulaByUuid, formulaTest, updateParam, updateParamFormula, updateRsFormulaParam, updateSingleRsFormulaParam } from '@/declare/api/system-lib/param';
import { ParamFormula, RsFormulaParam } from '@/declare/interface/system-lib/param-formula';
import classNames from 'classnames';
import ParamListComponent from './param-list';
import { ContextMenu, ContextMenuModal, Dropdown, IconButton, Input, LeftSideList, Modal } from 'bimui';
import { Param } from '@/declare/interface/system-lib/param';
import { ParamGroupType, ParamTypeOption, ParamGroupTypeOption, getParamTypeName, ParamType } from '@/declare/enums/param-type';
import TreeSelectComponent, { TreeSelectNode } from '@/layout/graphic/code/tree-select';
import { ParamGroup } from '@/declare/interface/system-lib/param-group';
import { TreeFirstMapItem } from './tree-tree-map';
import { ReactComponent as SearchSvg } from './icons/search.svg'
import { ReactComponent as DownSvg } from './icons/down.svg'
import { ReactComponent as ShowSvg } from './icons/show.svg'
import { ReactComponent as RsConstansSvg } from './icons/constans.svg'
import { ReactComponent as RsFunctionSvg } from './icons/function.svg'
import { ReactComponent as RsRandomSvg } from './icons/random.svg'
import { ReactComponent as RsMonitorSvg } from './icons/monitor.svg'
import { ReactComponent as CloseSvg } from './icons/close.svg'
import { ReactComponent as CreateSvg } from 'bimui/dist/c1/icons/create.svg';
import { ReactComponent as TestSvg } from 'bimui/dist/c1/icons/test.svg';
import { ReactComponent as RandomSvg } from 'bimui/dist/c1/icons/random-test.svg';
import { ReactComponent as ResetSvg } from 'bimui/dist/c1/icons/reset.svg'




import { BaseUtils } from 'tnbase';

const ParamDefineKey = {
    /**
     * 名称
     */
    NAME: "NAME",
    /**
     * 单位
     */
    UNIT: "UNIT",
    /**
     * 公式
     */
    FORMULA: "FORMULA",
    /**
     * 精度
     */
    ACCURACY: "ACCURACY",
    /**
     * 适用
     */
    APPLY: "APPLY",
    /**
     * 参数类型
     */
    TYPE: "TYPE",
}

const RightPanelType = {
    /**
     * 定义
     */
    DEFINE: "1",
    /**
     * 引用参数
     */
    RS_PARAM: "2",
    /**
     * 记录
     */
    RECORD: "3"
}

type ParamDefineKeyType = keyof typeof ParamDefineKey;

function isParamDefineKey(str: string): str is ParamDefineKeyType {
    return str in ParamDefineKey;
}

const codeTipString =
    "#python代码 请将公式的函数名命名为run\n" +
    "#run内定义的参数需要与参数的key一致\n" +
    "#如若有多个相同参数，则使用单下划线+数字进行区分，如 def run(angle_0, angle_1, angle_2)\n"

export default function CodePanel() {

    const { formulaId } = useParams()

    /**
     * 导航上下文
     */
    const navigateContext = useContext(NavigationContext);
    /**
     * 路由
     */
    const location = useLocation();

    /**
     * 代码编辑器中的代码
     */
    const [code, setCode] = useState<string>('');
    /**
     * 激活的类型（定义、引用参数、记录）
     */
    const [activeType, setActiveType] = useState<string>(RightPanelType.DEFINE)
    /**
     * 公式详情
     */
    const [formulaData, setFormulaData] = useState<ParamFormula>(null)
    /**
     * 编辑的条目的key
     */
    const [editItemKeyList, setEditItemKeyList] = useState<string[]>([])
    /**
     * 定义区域的数据
     */
    const [defineData, setDefineData] = useState<any[]>([])
    /**
     * 代码区是否被修改
     */
    const [modify, setModify] = useState<boolean>(false);
    /**
     * 引用参数模块被激活的项
     */
    const [showRsCheckItem, setShowRsCheckItem] = useState<number[]>([1, 2, 3, 4, 5, 6])
    /**
     * 关联参数弹窗显隐
     */
    const [rsParamModalVisible, setRsParamModalVisible] = useState<boolean>(false)
    /**
     * 关联弹窗top
     */
    const [rsParamModalTop, setRsParamModalTop] = useState<number>()
    /**
     * 关联弹窗left
     */
    const [rsParamModalLeft, setRsParamModalLeft] = useState<number>()
    /**
     * 关联弹窗里的数据
     */
    const [selectTreeData, setSelectTreeData] = useState<TreeSelectNode[]>([])
    /**
     * 关联的key列表
     */
    const [selectRsParamKeyList, setSelectRsParamKeyList] = useState<string[]>([])
    /**
     * 搜索文字
     */
    const [searchValue, setSearchValue] = useState<string>("")
    /**
     * 引用参数关联弹窗激活的类型
     */
    const [rsParamMenuType, setRsParamMenuType] = useState<number>(ParamGroupType.ENVIRONMENT)
    /**
     * 测试结果
     */
    const [testResult, setTestResult] = useState<string>("")

    /**
     * 监听参数标签页更改
     */
    useEffect(() => {
        generateData()
    }, [formulaId])

    useEffect(() => {
        if (!rsParamMenuType) return
        // 初始化关联参数弹窗中的列表数据
        findGroupMapListByType(rsParamMenuType).then(res => {
            let groupList: ParamGroup[] = res.data || []
            let tData = generateTreeData(groupList)
            setSelectTreeData([...tData])
        })
    }, [rsParamMenuType])

    /**
     * 监听代码修改，修改tab的保存状态
     */
    useEffect(() => {
        if (modify == null) {
            return
        }
        if (!formulaData) {
            return
        }
        navigateContext.setTabSave(location.pathname, !modify)
    }, [modify])

    /**
     * 初始化定义与代码区
     * @returns 
     */
    const generateData = () => {
        setTestResult("")
        if (!formulaId) return
        findParamFormulaByUuid(formulaId).then(res => {
            let formula: ParamFormula = res.data
            setFormulaData({ ...formula })
            if (!formula) return
            navigateContext.registTab({
                key: location.pathname,
                value: formula.param.name + "-" + formula.name,
            })
            if (!formula.formulaCode || formula.formulaCode.length === 0) {
                setCode(codeTipString);
            } else if (!formula.formulaCode.includes("#run内定义的参数需要与参数的key一致")) {
                setCode(codeTipString + formula.formulaCode);
            } else {
                setCode(formula.formulaCode);
            }

            navigateContext.setActiveTabKey(location.pathname)
            setDefineData([
                { key: ParamDefineKey.NAME, name: "名称", value: formula.param.name },
                { key: ParamDefineKey.UNIT, name: "单位", value: formula.param?.unit || "-" },
                { key: ParamDefineKey.FORMULA, name: "公式", value: formula?.formula || "-" },
                { key: ParamDefineKey.ACCURACY, name: "精度", value: formula.param?.accueacy || "-" },
                { key: ParamDefineKey.APPLY, name: "适用", value: "0.01" },
                { key: ParamDefineKey.TYPE, name: "类型", value: formula.param.type }
            ])
        })
    }
    /**
     * 根据传入的groupList转换成tree的数据结构
     * @param groupList 
     * @returns 
     */
    const generateTreeData = (groupList: ParamGroup[]) => {
        let treeData: TreeSelectNode[] = groupList.map(group => transformGroupToNode(group))
        return treeData
    }
    /**
     * 根据传入的group转换成tree的数据结构
     * @param groupList 
     * @returns 
     */
    const transformGroupToNode = (group: ParamGroup): TreeSelectNode => {
        let node: TreeSelectNode = {
            key: group.uuid,
            valueCount: 1,
            value1: group.name,
            unSelectable: true,
            children: []
        }
        if (group?.groupList?.length > 0) {
            group.groupList.forEach(childGroup => {
                node.children.push(transformGroupToNode(childGroup))
            })
        }
        if (group?.paramList?.length > 0) {
            group.paramList.forEach(childParam => {
                if (childParam.uuid != formulaData?.param?.uuid) {
                    node.children.push({
                        key: childParam.uuid,
                        valueCount: 2,
                        value1: childParam.name,
                        value2: childParam.keyCode,
                    })
                }

            })
        }
        return node
    }

    /**
     * 编辑输入框确认修改
     * @param item 
     * @param value 
     */
    const onConfrimEdit = (item: any, value: string) => {
        if (isParamDefineKey(item.key)) {
            if (item.key == ParamDefineKey.FORMULA) {
                let updateFormulaData: ParamFormula = {
                    formula: value
                }
                updateParamFormula(formulaId, updateFormulaData).then(res => {
                    generateData()
                }).catch(e => {
                    message.error("更新失败！")
                })
            } else {
                let updateParamData: Param = {}
                if (item.key == ParamDefineKey.ACCURACY) {
                    updateParamData.accueacy = value
                } else if (item.key == ParamDefineKey.NAME) {
                    updateParamData.name = value
                } else if (item.key == ParamDefineKey.UNIT) {
                    updateParamData.unit = value
                } else if (item.key == ParamDefineKey.TYPE) {
                    updateParamData.type = Number(value)
                }
                updateParam(formulaData.param.uuid, updateParamData).then(Res => {
                    generateData()
                }).catch(e => {
                    message.error("更新失败！")
                })
            }
        } else {
            // todo更新其余信息
        }
    }
    /**
     * 保存代码区修改
     */
    const onSave = (value: string) => {
        const allowedLibs = ['math', 'numpy', 'scipy', 'pandas', 'random', 'binascii', 'time', 'struct'];
        if (!isImportValid(code, allowedLibs)) {
            message.error(`请勿引入${allowedLibs.join("、")}以外的库！`)
            return;
        }
        updateParamFormula(formulaId, { formulaCode: value }).then(res => {
            message.success("保存成功！")
            setModify(false);
            generateData()
        }).catch(e => {
            message.error("修改失败！")
        })
    }

    /**
     * 测试点下
     */
    const onTest = () => {
        let testArgs = {}
        let rsParamList = formulaData.rsParamList
        rsParamList.forEach(param => {
            if (param.rsOrder?.length > 0) {
                testArgs[param.keyCode + "_" + param.rsOrder] = Number(param.testValue)
            } else {
                testArgs[param.keyCode] = Number(param.testValue)
            }
        })

        formulaTest(formulaId, testArgs).then(res => {
            if (res.data) {
                let params = ((res.data.params || []) as number[])
                params.map(param => param.toFixed(4));
                let paramStr = params.join(', ');
                // message.success(`参数:${paramStr}，结果:${res.data.result}`)
                let result: string = res.data.result
                if (result.includes("JepException")) {
                    setTestResult("测试报错！详见控制台（F12）")
                    console.log('err:', result)
                } else {
                    setTestResult(res.data.result)
                }
            }
        })
    }


    /**
     * 检查代码中是否引入了不允许的库
     * @param pythonCode python代码
     * @param allowedLibraries 允许的库名称
     * @returns 
     */
    const isImportValid = (pythonCode: string, allowedLibraries: string[]) => {
        // 使用正则表达式匹配所有 import 语句
        const importRegex = /import\s+(\w+)/g;

        let match;
        while ((match = importRegex.exec(pythonCode)) !== null) {
            const importedLibrary = match[1];
            if (!allowedLibraries.includes(importedLibrary)) {
                return false; // 如果导入了不允许的库，返回 false
            }
        }

        // 如果没有问题，返回 true
        return true;
    }

    /**
     * 确认关联引用参数
     */
    const onConfirmEditRsParam = () => {
        let updateRsData: RsFormulaParam[] = []
        selectRsParamKeyList.forEach((rsKey, index) => {
            updateRsData.push({
                formulaUuid: formulaId,
                rsParamUuid: rsKey,
                rsOrder: index + 1,
            })
        })
        updateRsFormulaParam(formulaId, updateRsData).then(res => {
            generateData()
        }).catch(() => {
            message.error("引用参数更新失败！")
        }).finally(() => {
            setRsParamModalVisible(false)
        })
    }

    /**
     * 打开关联参数弹窗，重新设置关联keyList
     */
    const onShowRsParamMenu = () => {
        // 重新设置关联keylist
        let keyList: string[] = []
        let rsParamList: Param[] = formulaData?.rsParamList || []
        rsParamList.forEach(rs => {
            keyList.push(rs.uuid)
        })
        setSelectRsParamKeyList(keyList)

        const dom = document.getElementById("rs-param-item");
        const rect = dom.getBoundingClientRect();
        setRsParamModalLeft(rect.left);
        setRsParamModalTop(rect.top + 16);
        setRsParamModalVisible(true)
    }

    /**
     * 根据参数类型获取参数名字的icon
     * @param param 
     * @returns 
     */
    const getRsParamNameIcon = (param: Param) => {
        if (param.type == ParamType.CONSTANT) {
            return <RsConstansSvg />
        } else if (param.type == ParamType.CALCULATION) {
            return <RsFunctionSvg />
        } else if (param.type == ParamType.COLLECTION) {
            return <RsMonitorSvg />
        } else if (param.type == ParamType.LIBRARY) {
            return <RsRandomSvg />
        }
        return <RsConstansSvg />
    }

    /**
     * 确定更新测试值
     * @param paramUuid 
     * @param value 
     */
    const onConfrimEditTestValue = (paramUuid: string, value: string, rsOrder: string) => {
        let rsParamList = formulaData.rsParamList
        updateSingleRsFormulaParam(formulaId, paramUuid, value, rsOrder).then(Res => {
            rsParamList.forEach(param => {
                if (param.uuid == paramUuid) {
                    if (rsOrder?.length > 0) {
                        if (rsOrder == param.rsOrder) {
                            param.testValue = value
                        }
                    } else {
                        param.testValue = value
                    }
                }
            })
            formulaData.rsParamList = rsParamList
            setFormulaData({ ...formulaData })
        })

    }

    /**
     * 清空测试值
     */
    const clearParamRandomValue = () => {
        let rsParamList = formulaData.rsParamList
        rsParamList.forEach(param => {
            param.testValue = ""
        })
        formulaData.rsParamList = rsParamList
        setFormulaData({ ...formulaData })
    }

    /**
     * 设置开始测试，将所有的参数都变成编辑状态
     */
    const onClickTestPrepara = () => {
        let rsParamList = formulaData?.rsParamList || []
        let editList: string[] = []
        rsParamList.forEach(param => {
            if (!(param.testValue?.length > 0)) {
                editList.push(param.uuid + param?.rsOrder)
            }
        })
        if (editList.length > 0) {
            setEditItemKeyList(editList)
        } else {
            onTest()
        }
    }

    return (
        <div className='code-panel'>
            <div className='code-area'>
                <CodeEditor
                    language='python'
                    code={code}
                    onSave={(c) => onSave(c)}
                    updateCode={(value) => {
                        setCode(value);
                        setModify(true)
                    }}
                    wrapClassName='graph-code-editor'
                />
                {/* <div className='code-bottom'>
                    <Button type='primary' onClick={() => { }}>复制</Button>
                    <Button type='primary' onClick={onTest}>测试</Button>
                    {
                        modify && <Button type='primary' onClick={onSave}>保存</Button>
                    }
                </div> */}
            </div>

            <div className='right-detail'>
                <div className='search-head'>
                    <Input
                        value={searchValue}
                        onChange={(e) => {
                            setSearchValue(e.target.value)
                        }}
                        wrapClassName='right-search-input'
                        prefix={<SearchSvg style={{ marginRight: 8, marginLeft: 8 }} />}
                    />
                    <div className='disable-select' >
                        设计
                        <DownSvg style={{ marginLeft: "auto" }} />
                    </div>
                </div>
                <div className='head'>
                    <div className={classNames({
                        'head-item': true,
                        'head-item-active': activeType == RightPanelType.DEFINE
                    })} onClick={() => { setActiveType(RightPanelType.DEFINE) }}>
                        定义
                    </div>
                    <div className={classNames({
                        'head-item': true,
                        'head-item-active': activeType == RightPanelType.RS_PARAM
                    })} onClick={() => { setActiveType(RightPanelType.RS_PARAM) }}>
                        引用参数
                    </div>
                    <div className={classNames({
                        'head-item': true,
                        'head-item-active': activeType == RightPanelType.RECORD
                    })} onClick={() => { setActiveType(RightPanelType.RECORD) }}>
                        记录
                    </div>
                </div>
                <div className='detail-body'>
                    {/* 定义显示 */}
                    {activeType == RightPanelType.DEFINE && (
                        <ParamListComponent
                            listData={defineData}
                            keyCode="key"
                            itemContainer={(item) => (
                                <div className='define-item'>
                                    <div className='name'>
                                        {item.name}
                                    </div>
                                    <div className='value' onDoubleClick={() => {
                                        setEditItemKeyList([item.key])
                                    }}>
                                        {editItemKeyList?.includes(item.key) ? (
                                            <>
                                                {item.key == ParamDefineKey.TYPE ? (
                                                    <Dropdown
                                                        options={ParamTypeOption}
                                                        defaultValue={item.value}
                                                        onChange={(e) => {
                                                            onConfrimEdit(item, e)
                                                            setEditItemKeyList([])
                                                        }}
                                                    />
                                                ) : (
                                                    <Input
                                                        defaultValue={item.value}
                                                        onBlur={(e) => {
                                                            onConfrimEdit(item, e.target.value)
                                                            setEditItemKeyList([])
                                                        }}
                                                        onEnter={(e) => {
                                                            let event = e as any
                                                            onConfrimEdit(item, event.target.value)
                                                            setEditItemKeyList([])
                                                        }}
                                                    />
                                                )}

                                            </>

                                        ) : (
                                            <>
                                                {item.key == ParamDefineKey.TYPE ? (getParamTypeName(item.value)) : (item.value)}
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        />
                    )}
                    {/* 引用参数显示 */}
                    {activeType == RightPanelType.RS_PARAM && (
                        <>
                            <div className='rs-head-btn-area'>
                                {/* <Tooltip title="关联参数">
                                    <div>
                                        <IconButton
                                            icon={<CreateSvg id='rs-param-item' style={{ width: 16, height: 16 }} />}
                                            onClick={() => {
                                                onShowRsParamMenu()
                                            }}
                                        />
                                    </div>
                                </Tooltip>
                                <Tooltip title="随机测试" >
                                    <div>
                                        <IconButton
                                            icon={<RandomSvg style={{ width: 16, height: 16 }} />}
                                        />
                                    </div>
                                </Tooltip> */}

                                <Tooltip title="自定义测试">
                                    <div>
                                        <IconButton
                                            onClick={() => { onClickTestPrepara() }}
                                            icon={<TestSvg style={{ width: 16, height: 16 }} />}
                                        />
                                    </div>
                                </Tooltip>

                                <Tooltip title="清空自定义">
                                    <div>
                                        <IconButton
                                            onClick={() => { clearParamRandomValue() }}
                                            icon={<ResetSvg style={{ width: 16, height: 16 }} />}
                                        />
                                    </div>
                                </Tooltip>
                            </div>
                            {testResult?.length > 0 && (
                                <div className='test-result'>
                                    <div className='result-icon'>
                                        !
                                    </div>
                                    <div className='result'>
                                        计算结果：{testResult}
                                    </div>
                                    <IconButton icon={<CloseSvg />} onClick={() => { setTestResult("") }} />
                                </div>
                            )}

                            <div className='rs-head-check'>
                                {ParamGroupTypeOption.map(option => (
                                    formulaData?.rsParamList?.filter(rs => rs.groupType == option.type)?.length > 0 && (
                                        <div key={option.type} className='check-item'>
                                            <div className='item-head'
                                                onClick={() => {
                                                    if (showRsCheckItem.includes(option.type)) {
                                                        setShowRsCheckItem(showRsCheckItem.filter(i => i != option.type))
                                                    } else {
                                                        setShowRsCheckItem([
                                                            ...showRsCheckItem,
                                                            option.type
                                                        ])
                                                    }
                                                }} >
                                                {option.label}
                                                <ShowSvg className={classNames({
                                                    'item-icon': true,
                                                    'item-icon-active': showRsCheckItem.includes(option.type)
                                                })} />
                                            </div>
                                            {showRsCheckItem.includes(option.type) &&
                                                formulaData?.rsParamList?.filter(rs => rs.groupType == option.type)?.map(rsParam => (
                                                    <div key={BaseUtils.genUUID()} className='item-child-item'>
                                                        <div className='item-name'>
                                                            {getRsParamNameIcon(rsParam)}
                                                            {rsParam.name}
                                                        </div>
                                                        <div className='item-black'>
                                                            {rsParam.keyCode + (rsParam.rsOrder?.length > 0 ? "_" + rsParam.rsOrder : "")}
                                                        </div>
                                                        <div className='item-black'>
                                                            {editItemKeyList?.includes(rsParam.uuid + rsParam?.rsOrder) ? (
                                                                <Input
                                                                    wrapClassName='black-input'
                                                                    defaultValue={rsParam?.testValue || ""}
                                                                    onBlur={(e) => {
                                                                        onConfrimEditTestValue(rsParam.uuid, e.target.value, rsParam?.rsOrder)
                                                                        setEditItemKeyList(editItemKeyList.filter(i => i != rsParam.uuid + rsParam?.rsOrder))
                                                                    }}
                                                                />
                                                            ) : (
                                                                <div onDoubleClick={() => {
                                                                    setEditItemKeyList([
                                                                        ...editItemKeyList,
                                                                        rsParam.uuid + rsParam?.rsOrder
                                                                    ])
                                                                }}>
                                                                    {rsParam?.testValue || "-"}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className='item-black'>
                                                            {rsParam?.unit || "-"}
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>
                                    )
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>

            <ContextMenuModal
                visible={rsParamModalVisible}
                onCancel={() => { setRsParamModalVisible(false) }}
                left={rsParamModalLeft}
                top={rsParamModalTop}
                wrapperClassname='rs-param-model'
            >
                <div className='model-main-body'>
                    <LeftSideList
                        wrapClassName='rs-param-model-left-side'
                        leftItems={ParamGroupTypeOption}
                        uniqueKey="type"
                        activeLeftItemKey={rsParamMenuType}
                        leftItemUpdateUuid={BaseUtils.genUUID()}
                        onClickLeftItem={(e, item) => {
                            setRsParamMenuType(item.type)
                        }}
                        leftItemContainer={({ leftItem }) => {
                            return (
                                <div>{leftItem.label}</div>
                            );
                        }}
                        noNeedAddIcon
                    />
                    <TreeSelectComponent
                        treeList={selectTreeData}
                        selectKeyList={selectRsParamKeyList}
                        setSelectKeyList={(key) => {
                            if (selectRsParamKeyList.includes(key)) {
                                setSelectRsParamKeyList([...selectRsParamKeyList.filter(k => k != key)])
                            } else {
                                setSelectRsParamKeyList([
                                    ...selectRsParamKeyList,
                                    key
                                ])
                            }
                        }}
                    />
                </div>
                <div className='btn-area'>
                    <div className='btn save-btn' onClick={() => {
                        onConfirmEditRsParam()
                    }}>
                        确定
                    </div>
                    <div className='btn cancel-btn'
                        onClick={() => {
                            setRsParamModalVisible(false)
                        }}
                    >
                        取消
                    </div>
                </div>

            </ContextMenuModal>

        </div>
    )
}

